// author：jiana
// time:2024-06-12
// desc:本页面为方便快速构建vue文件模板基础页面搭建，在次基础上快速搭建

<template>
	<div class="footerBox">
		<div class="box1200">
			<el-row :gutter="10">
				<el-col :span="18">
					<el-row :gutter="10" class="infoDiv">
						<el-col :span="4">
							<div class="footTitle">关于我们</div>
							<div @click="$jump('/companyIntroduction?type=1')">企业简介</div>
							<div @click="$jump('/companyIntroduction?type=2')">发展历程</div>
							<div @click="$jump('/companyIntroduction?type=3')">企业文化</div>
							<div @click="$jump('/companyIntroduction?type=4')">logo释义</div>
							<div @click="$jump('/companyIntroduction?type=5')">荣誉资质</div>
							<div @click="$jump('/socialResponsibility')">社会责任</div>
							<div @click="$jump('/serviceCommitment')">服务承诺</div>
							<div @click="$jump('/buildGarden')">党建园地</div>
						</el-col>
						<el-col :span="4">
							<div class="footTitle">资讯中心</div>
							<div @click="$jump('/InformationCenter?type=zxzx_001_001')">新闻速递</div>
							<div @click="$jump('/InformationCenter?type=zxzx_001_002')">招标公告</div>
							<div @click="$jump('/InformationCenter?type=zxzx_001_003')">其他公告</div>
							<div @click="$jump('/InformationCenter?type=zxzx_001_004')">行情资讯</div>
						</el-col>
						<el-col :span="8">
							<div class="footTitle">产品中心</div>
							<el-row>
								<el-col :span="12" v-for="item,index in menuList" :key="index">
									<div @click="handleCommandThree(item)">{{item.name}}</div>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="4">
							<div class="footTitle">技术服务</div>
							<div v-for="item,index in menuListOne" :key="index" @click="handleCommandThree(item)">{{item.name}}</div>
						</el-col>
						<el-col :span="4">
							<div class="footTitle">联系我们</div>
							<div @click="$jump('/recruitPeople')">招贤纳士</div>
							<div @click="$jump('/contactInfomation')">申诉建议</div>
							<div @click="$jump('/cooperation')">意向合作</div>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="6">
					<div class="footTitle"></div>
					<el-row :gutter="10">
						<el-col :span="12">
							<div class="imgBox"><img src="../../assets/imgs/app.svg" alt=""></div>
							<div class="banben">爱养牛app下载</div>
						</el-col>
						<el-col :span="12">
							<div class="imgBox"><img src="../../assets/imgs/douying.png" alt=""></div>
							<div class="banbenOne">抖音号</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<div class="linkBox">
				<el-row :gutter="10">
					<el-col :span="18">
						<div class="marginTop21" style="font-weight:bold;">友情链接：
							<a href="https://www.cofco.com/cn/BrandProduct/COFCOWinesSpirits/" target="_blank">中粮集团</a> &nbsp; &nbsp;&nbsp; 
							<a href="https://www.mengniu.com.cn/" target="_blank">蒙牛集团</a> &nbsp; &nbsp;&nbsp; 
							<a href="https://www.xiandaimuye.com/index.html" target="_blank">现代牧业</a>&nbsp; &nbsp; &nbsp;
							<a href="http://www.shengmuorganicmilk.com/home/index/index.html" target="_blank">中国圣牧</a>&nbsp; &nbsp; &nbsp;
							<a href="https://www.yunyangniu.com/" target="_blank">云养牛</a></div>
					</el-col>
					<el-col :span="6">
						<el-row>
							<el-col :span="8">
								<div class="imgBoxOne"><img src="../../assets/imgs/gongzhonghao.jpg" alt=""></div>
								<div style="margin-left: 5px;">微信公众号</div>
							</el-col>
							<!-- <el-col :span="6">
								<div class="imgBoxOne"><img src="../../assets/imgs/douying.png" alt=""></div>
								<div style="text-align: center;">抖音号</div>
							</el-col> -->
							<el-col :span="8">
								<div class="imgBoxOne"><img src="../../assets/imgs/shipinghao.jpg" alt=""></div>
								<div style="margin-left: 17px;">视频号</div>
							</el-col>
							<el-col :span="8">
								<div class="imgBoxOne"><img src="../../assets/imgs/niurenhui.jpg" alt=""></div>
								<div>牛人慧公众号</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<div class="xieyi">
				<div class="xyBox">
					<span>Copyright © 2024 内蒙古爱养牛科技有限公司</span>
					<span v-for="item,index in imageList" :key="index">
						<span v-if="item.link" @click="open(item.link)">
							<img :src="item.url" class="liangzhao"/>
							<span>{{item.name}}</span>
						</span>
						<span v-else @click="open(item.url)">
							{{item.name}}
						</span>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {resourceList,treeCodeList} from '../../request/service'
export default {
	name: 'template',
	components: {

	},
	props:{
		
	},
	data() {
		return {
			imageList:[],
			menuList:[],
			menuListOne:[],
		}
	},
	computed: {

	},
	methods: {
		//第一屏
		getImage(){
			resourceList({typeCode:'sy_006'}).then((res) => {
				if(res.code == 101){
					this.imageList = res.data
				}else{
					this.$Message.error(res.message);
				}
			})
		},
		open(url){
			window.open(url)
		},
		handleCommandThree(item){
			if(item.isRedirect == 1){  //设置了跳转
				if(item.link.indexOf('www.aiyangniu.net') !== -1 || item.link.indexOf('www.aiyangniu.cn') !== -1){  
					this.$jump({path:item.link.split("#")[1]})
				}else{
					window.open(item.link)
				}
			}
		},
		getMenu(){
			treeCodeList({typeCode:'cpzx_001'}).then((res) => {
				if(res.code == 101){
					this.menuList = res.data
				}else{
					this.$Message.error(res.message);
				}
			})
		},
		getMenuOne(){
			treeCodeList({typeCode:'jsfw_001'}).then((res) => {
				if(res.code == 101){
					this.menuListOne = res.data
				}else{
					this.$Message.error(res.message);
				}
			})
		},
	},

	mounted() {
		this.getImage()
		this.getMenu()
		this.getMenuOne()
	},

	watch: {

	}
}
</script>

<style lang="less" scoped>
.footerBox{
	width: 100%;
	padding: 20px 0;
	// background: rgba(245, 245, 249, 0.45);
	.box1200{
		width: 1200PX;
		margin: 0 auto;
		color: rgb(102, 105, 111);
	}
	.infoDiv{
		div{
			line-height: 20px;
			cursor: pointer;
		}
	}
	.footTitle{
		color: rgb(43, 44, 46);
		font-size: 10px;
		margin-bottom: 5px;
		font-weight: 500;
	}
	.marginTop21{
		margin-top: 21px;
	}
	.imgBox{
		width: 80px;
		height: 80px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.banben{margin-left:12px;margin-top: 5px;}
	.banbenOne{margin-left:26px;margin-top: 5px;}
	.linkBox{
		margin-top: 20px;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding: 10px 0;
		color: rgb(102, 105, 111);
	}
	.imgBoxOne{
		width: 50px;
		height: 50px;
		// margin: auto;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.xieyi{
		width: 82%;
		margin: auto;
		text-align: center;
		color: rgb(154, 160, 170);
		line-height: 40px;
		div{
			padding-top: 10px;
		}
		span{
			margin-right: 5px;
			cursor: pointer;
		}
	}
	.liangzhao{
		width: 10px;
		height: 10px; 
	}
	a{
		color: #66696f;
	}
}
</style>
